import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'

interface GetMenuListProps {
  cb?: (venues: any) => void
}


export const getMenuList = createAsyncThunk('menuList/getMenuList',
  async ({ cb }: GetMenuListProps) => {
    const url = 'v1/user-info/menu-list'
    const response: AxiosResponse<string[]> = await instance.get(url)
    window.localStorage.setItem('menu_list', JSON.stringify(response.data))
    if (cb) {
      cb(response.data)
    }
    return response.data
  })
